// extracted by mini-css-extract-plugin
export default {"cell":"HeatMap_cell__GoISO"};